export default __webpack_public_path__ + "static/media/drum_roll.b7f86b47.mp3";